import Image from 'next/image';
import image from '../../../public/icons/StripeLogo-slate.svg';
import styles from './StripeLogo.module.scss';

export const StripeLogo = () => (
	<span className={ styles.stripeLogo }>
		<Image src={ image.src } alt='Stripe Logo' height={ 24 } width={ 48 } />
	</span>
);
